export default "__VITE_ASSET__CrF$HOz7__"